import {
  BOT_SCORE_COOKIE_NAME,
  IS_VERIFIED_BOT_COOKIE_NAME,
} from '@repo/platform-middleware/constants';
import { isLikelyABotBasedOnScore } from '@repo/utils/getCFBotHeaders';
import cookies from 'js-cookie';
import * as v from 'valibot';

const verifiedBotSchema = v.pipe(
  v.string('verifiedBot must be a boolean string'),
  v.transform(value => value === '1'),
  v.boolean(),
);
const botScoreSchema = v.pipe(
  v.string('botScore must be a numeric string'),
  v.transform(Number),
  v.number('botScore must be a valid number'),
);

export function getBotCookies() {
  const botScore = cookies.get(BOT_SCORE_COOKIE_NAME) ?? '';
  const isVerifiedBot = cookies.get(IS_VERIFIED_BOT_COOKIE_NAME) ?? '';

  const validatedIsVerifiedBot = v.safeParse(verifiedBotSchema, isVerifiedBot);
  const validatedBotScore = v.safeParse(botScoreSchema, botScore);

  const score = validatedBotScore.success ? validatedBotScore.output : 0;
  const isAKnownConfirmedBot = validatedIsVerifiedBot.success
    ? validatedIsVerifiedBot.output
    : false;

  return {
    botScore: score,
    isBot: isLikelyABotBasedOnScore(score),
    isVerifiedBot: isAKnownConfirmedBot,
  };
}
